import { render, staticRenderFns } from "./AppHeader--Mobile.vue?vue&type=template&id=054b7bc6&lang=pug&"
import script from "./AppHeader--Mobile.vue?vue&type=script&lang=js&"
export * from "./AppHeader--Mobile.vue?vue&type=script&lang=js&"
import style0 from "./AppHeader--Mobile.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports